import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';
import { Usuario } from '../model/usuario';
import { Permisos } from '../model/permisos';

import { UtilitiesService } from '../services/utilities.service'

@Injectable()
export class SeguridadService {

  constructor(
    private _http: Http,
    private _utilities: UtilitiesService
  ) { }


  getPermisos(usuario: Usuario): Observable<Permisos[]> {

    let json = { "Metodo": "getPermisosUsuario", "Datos": usuario };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json());

  }

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/services/seguridad.service.ts